module.exports = __webpack_public_path__ + "img/ESG_tv_bevezetés_MF.f55fe897.png";